import gql from "graphql-tag";

import { fragmentAddress } from "./address";

export const shopFragment = gql`
  ${fragmentAddress}
  fragment ShopFragment on Shop {
    authorizationKeys {
      key
      name
    }
    companyAddress {
      ...AddressFragment
    }
    allCountries {
      code
      country
      regions{
        code
        name
      }
    }
    countries {
      code
      country
      regions{
        code
        name
      }
    }
    customerSetPasswordUrl
    defaultMailSenderAddress
    defaultMailSenderName
    description
    domain {
      host
    }
    name
    title
    keywords
    shopApiUri
    shopViewPageManageUri
  }
`;
